import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CalendarModalOptions } from 'ion2-calendar';
import { AddCall } from 'src/providers/addvCall';

@Component({
  selector: 'app-advance-filter',
  templateUrl: './advance-filter.page.html',
  styleUrls: ['./advance-filter.page.scss'],
})

export class AdvanceFilterPage implements OnInit {
  dateInfo: any;
  year: string;
  month: string;
  day: any;
  curntDate: any;
  searchData: { costValue: any; distance: any; offers: any; selectedDate: any; };
  costRange: any;
  distanceRange: any;
  offerRange: any;
  selectedDate: any;

  constructor(
    public modalCtrl: ModalController,
    public addCall: AddCall,
  ) { }

  
  ngOnInit() {
    //current date only//
    let date = new Date();
    let day = date.toLocaleString('en-us', { weekday: 'long' });
    console.log(day);
    this.curntDate = new Date();
    this.curntDate = String(this.curntDate).split(" ");
    this.year = this.curntDate[3];
    this.month = this.curntDate[1];
    this.day = day;
    //--------------------//
  }
  //calender typescript only

  onChange($event) {
    console.log($event);
    this.dateInfo = $event;
    let item = this.dateInfo._d;
    let dateArray = String(item).split(" ");
    this.year = dateArray[3];
    this.month = dateArray[1];
    this.day = item.toLocaleString('en-us', { weekday: 'long' });
    console.log(dateArray[1] + "/" + dateArray[3]);
    console.log(item);
    this.selectedDate=item.getFullYear()+"-"+("0"+(item.getMonth()+1)).slice(-2)+"-"+("0"+item.getDate()).slice(-2);
    console.log("slctedDate=>",this.selectedDate);
  }
  dateMulti: string[];
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  optionsMulti: CalendarModalOptions = {
    pickMode: 'single',
    // weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    weekdays: [this.addCall.title411,this.addCall.title412,this.addCall.title413,this.addCall.title414,this.addCall.title415,this.addCall.title416,this.addCall.title417],
    
    disableWeeks: [5],
  };


  dismiss(value) {
    this.searchData={
      "costValue":this.costRange,
      "distance":this.distanceRange,
      "offers":this.offerRange,
      "selectedDate":this.selectedDate
    };
    if (value == "search") {
      this.modalCtrl.dismiss(this.searchData);
    }
    else{
      this.modalCtrl.dismiss();
    }
  }
}
